import styled from '@emotion/styled';

export default styled.div<{ gap?: number; height?: number }>`
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap ?? 0}px;
`;
